import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import OnboardingStepper from "components/Account/Onboarding/OnboardingStepper";
import TextArea from "components/General/Form/TextArea";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "containers/Account/Onboarding/Onboarding.css";
import AxiosConfig from "axiosConfig";

class Dream extends React.Component {
	state = {
		dream: "",
		heroes: "",
	};

	componentDidMount() {
      AxiosConfig.get("profile/details/").then((res) => {
          this.setState({
              dream: res.data.dream,
              heroes: res.data.heroes,
          });
      });
    }

	onDataChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	createFormData() {
		let form_data = new FormData();
		if (this.state.dream) form_data.append("dream", this.state.dream);
		form_data.append("heroes", this.state.heroes);
		return form_data;
	}

	onNextClicked(event) {
		event.preventDefault();
		let form_data = this.createFormData();

		return AxiosConfig.put("profile/details/", form_data, {
			headers: { "content-type": "multipart/form-data" },
		})
			.then(this.props.history.push(`/onboarding-superpower`))
			.catch();
	}

	onSkipClicked(event) {
		this.props.history.push(`/onboarding-superpower`);
	}

	render() {
		return (
			<div>
				<div className="onboarding_header">
					<div className="onboarding_header_text">
						<TextTheme
							message="Before we start, let's build your"
              className="text_xm text_white text_bold"
						/>
						<TextTheme
							message="Personalized Social Impact Profile!"
              className="text_xm text_white text_bold"
						/>
					</div>
					<div className="onboarding_header_stepper">
						<OnboardingStepper currentOnboardingStep="1" />
					</div>
				</div>
				<div className="onboarding_content">
					<div style={{ marginTop: "20px" }}>
						<TextArea
							title="I have a dream, that one day..."
							rows="6"
							placeholder="If you could change anything in the world to make it better, what would it be?"
							name="dream"
							value={this.state.dream}
							handleChange={this.onDataChange.bind(this)}
						/>
					</div>
					<div style={{ marginTop: "20px" }}>
						<TextArea
							title="My Heroes"
							rows="6"
							placeholder="Who inspires you to become the best person you can be?"
							name="heroes"
							value={this.state.heroes}
							handleChange={this.onDataChange.bind(this)}
						/>
					</div>

					<div className="onboarding_button_options">
						<RoundedButton
							title="Skip for now, maybe later."
							buttonClassName="background_white"
							textThemeClassName="text_medium text_dark_orange"
							handleOnClick={this.onSkipClicked.bind(this)}
						/>
						<RoundedButton
							title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
							buttonClassName="background_dark_orange"
							textThemeClassName="text_medium text_white"
							handleOnClick={this.onNextClicked.bind(this)}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default Dream;
